export default __webpack_public_path__ + "static/media/Human3.31501710.png";